import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
import {
	ICommercialStructureByIdResponse,
	ICommercialStructureCreateRequest,
	ICommercialStructureDisable,
	ICommercialStructureQueryRequest,
	ICommercialStructureQueryResponse
} from "../interfaces/commercial-structure.interface";
import { IFilterCommercialStructureRequest } from "../interfaces/filter.interface";
import { IResponseData, IResponseListDataPaginate } from "../interfaces/response-data.interface";

@Injectable({
	providedIn: "root"
})
export class CommercialStructureService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	getAll(
		request: ICommercialStructureQueryRequest
	): Observable<IResponseListDataPaginate<ICommercialStructureQueryResponse>> {
		let params = new HttpParams();
		if (request.name !== "" && request.name !== undefined && request.name !== null) {
			params = params.append("name", request.name);
		}
		if (request.brokerName !== "" && request.brokerName !== undefined && request.brokerName !== null) {
			params = params.append("brokerName", request.brokerName);
		}
		if (request.productId !== "" && request.productId !== undefined && request.productId !== null) {
			params = params.append("productId", request.productId);
		}
		if (request.status !== "" && request.status !== undefined && request.status !== null) {
			params = params.append("status", request.status);
		}
		if (request.page !== undefined) {
			params = params.append("page", request.page.toString());
		}
		if (request.pageSize !== undefined) {
			params = params.append("pageSize", request.pageSize.toString());
		}
		return this.http.get<IResponseListDataPaginate<ICommercialStructureQueryResponse>>(
			`${environment.urlApi}/CommercialStructure/GetAll`,
			{ params }
		);
	}

	getByFilters(request: IFilterCommercialStructureRequest): Observable<any> {
		let params = new HttpParams();
		if (request.name !== "" && request.name !== undefined) {
			params = params.append("name", request.name);
		}
		return this.http.get<any>(`${environment.urlApi}/CommercialStructure/GetByFilters`, { params });
	}

	getByEntity(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/CommercialStructure/GetByEntity`);
	}

	getById(id: number, pageCommercialStructure: boolean): Observable<IResponseData<ICommercialStructureByIdResponse>> {
		return this.http.get<IResponseData<ICommercialStructureByIdResponse>>(
			`${environment.urlApi}/CommercialStructure/GetById?id=${id}&pageCommercialStructure=${pageCommercialStructure}`
		);
	}

	proposalGetCommercialStructureById(id: number): Observable<IResponseData<ICommercialStructureByIdResponse>> {
		return this.http.get<IResponseData<ICommercialStructureByIdResponse>>(
			`${environment.urlApi}/Proposal/GetCommercialStructureGetById?id=${id}`
		);
	}

	update(request: ICommercialStructureCreateRequest): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/CommercialStructure/Put`, request);
	}

	post(request: ICommercialStructureCreateRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/CommercialStructure/Post`, request);
	}

	disableCommercialStructure(id: number): Observable<any> {
		const request: ICommercialStructureDisable = { id: id };
		return this.http.post<any>(`${environment.urlApi}/CommercialStructure/Disable`, request);
	}
}
